import { UserCog } from "lucide-react";
import { TeamProfileAutocomplete } from "@/dentlab/src/forms/form-input-components/selects/team-profile-autocomplete";
import { TooltipWrapper } from "@/dentlab/src/components/ui/tooltip-wrapper";
import { useJobStore } from "@/dentlab/src/store/Jobs";

export const DefaultTechnicianSelect: React.FC = () => {
	const { defaultTechnician, setDefaultTechnician } = useJobStore(
		(state) => ({
			defaultTechnician: state.defaultTechnician,
			setDefaultTechnician: state.setDefaultTechnician,
		})
	);

	return (
		<div
			className="flex items-center"
			data-testid="default-technician-select"
		>
			<TooltipWrapper title="Standard-Techniker">
				<span className="mr-1.5 flex shrink-0 items-center">
					<UserCog
						className="h-4 w-4 text-muted-foreground"
						aria-hidden
					/>
				</span>
			</TooltipWrapper>
			<div className="w-32">
				<TeamProfileAutocomplete
					value={defaultTechnician}
					placeholder="Kein Techniker"
					onChange={(value) => setDefaultTechnician(value)}
				/>
			</div>
		</div>
	);
};
